module.exports = __webpack_public_path__ + "c3102980823db2d0cb449c8fb7487bd1.svg";